import { Role } from "@/@types/app/Role";
import { appApi } from "../api";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";

export async function getAllProfiles(module?: ModuleEnum) {
	const { data } = await appApi.get<Role[]>("/profile", { module });
	return data || [];
}
